"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECONNECT_REJECTED = exports.RECONNECT_PENDING = exports.RECONNECT_FULFILLING = exports.RECONNECT_FULFILLED = exports.RECONNECT = void 0;
var RECONNECT = 'DIRECT_LINE/RECONNECT';
exports.RECONNECT = RECONNECT;
var RECONNECT_FULFILLED = "".concat(RECONNECT, "_FULFILLED");
exports.RECONNECT_FULFILLED = RECONNECT_FULFILLED;
var RECONNECT_FULFILLING = "".concat(RECONNECT, "_FULFILLING");
exports.RECONNECT_FULFILLING = RECONNECT_FULFILLING;
var RECONNECT_PENDING = "".concat(RECONNECT, "_PENDING");
exports.RECONNECT_PENDING = RECONNECT_PENDING;
var RECONNECT_REJECTED = "".concat(RECONNECT, "_REJECTED");
exports.RECONNECT_REJECTED = RECONNECT_REJECTED;